export enum GroupDetailListContent {
	MEMBERS = 'members',
	MEMBERS_ADD = 'membersAdd',
	MEMBERS_REMOVE = 'membersRemove',
}
